let base = window._env_.VUE_APP_ADMIN_HOST

// 员工列表
export const getEmployeeList = (params = {}) => {
  return axios.post(`${base}/employees/query`, params)
}

// 新增员工
export const addEmployee = params => {
  return axios.post(`${base}/employees/create`, params)
}

// 编辑员工
export const editEmployee = (params = {}) => {
  const { id, ...rest } = params
  return axios.post(`${base}/employees/edit_${id}`, rest)
}

// 员工详情
export const getEmployeeDetail = (id) => {
  return axios.get(`${base}/employees/get_${id}`)
}

// 删除员工
export const deleteEmployee = (id) => {
  return axios.post(`${base}/employees/delete_${id}`)
}

// 导入员工数据
export const importEmployees = (params = {}) => {
  return axios.post(`${base}/employees/import`, params)
}

// 导出邮件记录
// params: { type: 1|2, start_at: "YYYY-MM-DD", end_at: "YYYY-MM-DD" }
// type: 1=周年, 2=生日
export const exportEmployeeGreetings = (params = {}) => {
  return axios.post(`${base}/employees/export_greetings`, params, {
    responseType: 'blob',
  })
}

// 保存生日礼物
// params: { employee_id: 1, gift: "" }
export const addBirthdayGreetings = (params = {}) => {
  return axios.post(`${base}/employees/add_birthday_greetings`, params)
}

// 查询生日发送记录
// params: { name: "", status: "" }
// status: 0=待发送, 1=已发送, 2=发送失败, 3=已取消
export const getBirthdayGreetingsRecord = (params = {}) => {
  return axios.post(`${base}/employees/birthday_greetings_record`, params)
}

// 取消生日发送
// params: { record_id: 1 }
export const cancelBirthdayGreetings = (params = {}) => {
  return axios.post(`${base}/employees/cancel_birthday_greetings`, params)
}



// WEBPACK FOOTER //
// ./src/views/hr/hr.api.js